import { Close, LocationCityOutlined } from "@mui/icons-material";
import { Dialog, DialogContent, DialogTitle, Divider, FormControl, IconButton, InputAdornment, Stack, Typography } from "@mui/material";
import IndieNumberField from "components/forms/IndieNumberField";
import IndieStaticSelect from "components/forms/IndieStaticSelect";
import { AgentEntityContextProvider } from "contexts/agents/AgentEntityContext";
import { CommunityContextProvider } from "contexts/communities/CommunityContext";
import { TariffsContextProvider } from "contexts/tariffs/TariffsContext";
import { t } from "i18next";
import _ from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import CommunityBusinessTypeSelector from "components/forms/communities/CommunityBusinessTypeSelector";
import { AggregationCommunityForm } from "./AggregationCommunityForm";
import { CommunitiesCommunityForm } from "./CommunitiesCommunityForm";

export const communitySharingTypes = [
    {
        code: "proportional",
        name: "Proporcional",
        description: "Partilha com coeficientes proporcionais ao consumo",
        disabled: false
    },
    {
        code: "fixed",
        name: "Fixo",
        description: "Partilha com coeficientes fixos",
        disabled: true
    },
    {
        code: "dynamic",
        name: "Dinâmico",
        description: "Partilha com coeficientes dinâmicos",
        disabled: true
    }
];

export const CommunitySharingTypeSelect = (props) => {

    const { t } = useTranslation();

    return (
        <IndieStaticSelect
            options={communitySharingTypes.map((st) => ({ value: st.code, label: st.name }))}
            label={t("label.form.sharingType")}
            sx={{ width: 250 }}
            {...props}
        />
    )
}
export const IndieLabelAndValue = ({ label, value }) => {
    const { t } = useTranslation();

    return (
        <Stack direction={"row"} spacing={2}>
            <Typography variant='subtitle2' color='textSecondary'>{t(label)}:</Typography>
            <Typography variant='body2' color='textSecondary'>{value} </Typography>
        </Stack>
    );
}

export const IndieDSOIDField = ({ type, ...props }) => {
    return (
        <FormControl>
            <Stack direction={"row"} spacing={2} sx={{ alignItems: "flex-end" }}>
                <IndieNumberField {...props}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <Typography variant="body1" color="textSecondary">/ {_.upperCase(type)}</Typography>
                            </InputAdornment>
                        ),
                    }}
                />
            </Stack>
        </FormControl>
    );
}

const NewCommunityDialog = ({ open, handleClose, handleSuccess, businessType, initialData = null }) => {
    return (
        <AgentEntityContextProvider>
            <CommunityContextProvider>
                <NewCommunityDialogContent 
                    open={open} 
                    handleClose={handleClose} 
                    handleSuccess={handleSuccess} 
                    business={businessType}
                    initialData={initialData}
                />
            </CommunityContextProvider>
        </AgentEntityContextProvider>
    )
};

const NewCommunityDialogContent = ({ open, handleClose, handleSuccess, business, initialData }) => {
    const [businessType, setBusinessType] = useState(business);

    const handleBusinessTypeChange = (newBusinessType) => {
        setBusinessType(newBusinessType);
    }

    return (
        <Dialog open={open} fullScreen>
            <DialogTitle>
                <Stack spacing={2} direction="row" alignItems="center">
                    <IconButton onClick={handleClose}>
                        <Close />
                    </IconButton>
                    <LocationCityOutlined color="primary" />
                    <Typography variant="subtitle1" color="textPrimary">{t("label.menu.addCommunity")}</Typography>
                </Stack>
            </DialogTitle>
            <DialogContent>
                <TariffsContextProvider>
                    <Divider fullWidth sx={{ mb: 2 }} />
                    {!businessType && (
                        <Stack spacing={2} mb={2}>
                            <Typography variant="subtitle2">{t("label.step.newAgentCommunity.communityBusinessTypeStep.subtitle")}</Typography>
                            <CommunityBusinessTypeSelector currentBusinessType={businessType} handleBusinessTypeChange={handleBusinessTypeChange} />
                        </Stack>
                    )}
                    {businessType ? businessType === "aggregation" ? (
                        <AggregationCommunityForm handleSuccess={handleSuccess} initialData={initialData} />
                    ) : (
                        <CommunitiesCommunityForm handleSuccess={handleSuccess} />
                    ) : null}
                    
                </TariffsContextProvider>
            </DialogContent>
        </Dialog>
    );
}

export default NewCommunityDialog;